import { useSelector } from 'react-redux';

import { bundleVersionSelector } from '../stateSelector';

const useBundleVersion = (): string => useSelector(bundleVersionSelector);

export default useBundleVersion;
